import React, { useState, useEffect } from "react";
import CustAccount from "../../../sections/CustomerDashboard/Settings/CustAccount";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { Formik, Form } from "formik";
import useAuth from "../../../Hooks/useAuth";

const CustomerAccount = () => {
  const { auth } = useAuth();
  
  // Set initial values
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    primaryLocation: "",
    email: "",
    mobileNumber: "",
    profilePicture: null
  });

  // Prefill form with user data from auth
  useEffect(() => {
    if (auth) {
      setInitialValues({
        firstName: auth.firstName || "",
        lastName: auth.lastName || "",
        primaryLocation: auth.location || "",
        email: auth.personalEmail || auth.tradesPosterEmail || "",
        mobileNumber: auth.primaryContactNumber || "",
        profilePicture: auth.profilePicture || null
      });
    }
  }, [auth]);

  const handleSubmit = (values) => {
    console.log("Form data:", values);
  };

  return (
    <>
      <DashboardMainContainer className={"!bg-white"}>
        <div className="flex justify-center">
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ setFieldValue, values }) => (
              <Form className="w-full">
                <CustAccount values={values} setFieldValue={setFieldValue} />
              </Form>
            )}
          </Formik>
        </div>
      </DashboardMainContainer>
    </>
  );
};

export default CustomerAccount;
